import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import styles from './index.scss';
import { triggerPasswordReset } from 'services';
import { Mail, Check } from 'react-feather';

export interface IPasswordResetProps {
  email: string;
  className?: string;
  children?: React.ReactNode;
}

const DEFAULT_TEXT = 'Reset Password';

const PasswordReset: React.FC<IPasswordResetProps> = ({
  email,
  className,
  children = DEFAULT_TEXT,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleClick = useCallback(() => {
    triggerPasswordReset(email).then(() => {
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    });
  }, [email]);

  return (
    <div className={classnames(styles.passwordReset, className)}>
      <div className={styles.resetButtonText} onClick={handleClick}>
        <Mail className={styles.icon} />
        <div className={styles.text}>{children}</div>
      </div>
      {showSuccess && (
        <div className={styles.successMessageContainer}>
          <Check className={styles.successIcon} />
          <div>A reset password email has been sent to {email}</div>
        </div>
      )}
    </div>
  );
};

export default React.memo(PasswordReset);
